import { Coins } from "lucide-react";

export function CoinBadge({ value, size = "md", testId }) {
  const dims = size === "sm" ? "text-xs px-2 py-0.5 gap-1" : "text-sm px-2.5 py-1 gap-1.5";
  const icon = size === "sm" ? 13 : 15;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center rounded-full border border-coin/40 bg-coin/10 font-mono font-semibold text-coin ${dims}`}
    >
      <Coins size={icon} strokeWidth={2.4} />
      {value}
      <span className="opacity-70 font-sans font-normal">Dimagi</span>
    </span>
  );
}
